import fetch from 'cross-fetch'
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'

export const client = new ApolloClient({
  link: new HttpLink({
    // uri: 'https://tekninenprod.local/graphql',
    uri: process.env.GATSBY_WPGRAPHQL_URL || 'https://tekninendev.wpenginepowered.com/graphql',
    fetch,
  }),
  cache: new InMemoryCache(),
})
